export default "__VITE_ASSET__9dcb9747__"